
class MaisonLanguageChoice extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    this.dataset.ready = 'true';
    const options = { signal: this.abortController.signal };
    const details = this.querySelector('details');
    const summary = this.querySelector('summary');
    summary.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
    }, options);
    document.addEventListener('click', event => {
      if (!this.contains(event.target)) details.open = false;
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        summary.focus();
      }
    }, options);

  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }
}
if (!customElements.get('ma-language-choice')) customElements.define('ma-language-choice', MaisonLanguageChoice);
